import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { DashboardData, UpdateJobStafferRequest } from "@/types";

// Adds/removes a staffer across a job's active reqs. Optimistic so the
// multiselect reacts instantly; every dashboard view is patched because the
// cache is keyed per selected staffer.
export function useUpdateSetJobStaffers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      jobId,
      userId,
      isSelected,
    }: UpdateJobStafferRequest) => {
      await guacHttpClient.put("requisition-owners/job", {
        jobId,
        userId,
        isSelected,
      });
    },
    onMutate: async ({ jobId, userId, isSelected }) => {
      await queryClient.cancelQueries({ queryKey: ["dashboard"] });
      const previousDashboards = queryClient.getQueriesData<DashboardData>({
        queryKey: ["dashboard"],
      });

      queryClient.setQueriesData<DashboardData>(
        { queryKey: ["dashboard"] },
        (data) => {
          if (!data) return data;
          return {
            ...data,
            jobs: data.jobs.map((job) => {
              if (job.id !== jobId) return job;
              const ownerUserIds = isSelected
                ? [...job.ownerUserIds, userId]
                : job.ownerUserIds.filter((id) => id !== userId);
              return { ...job, ownerUserIds };
            }),
          };
        },
      );

      return { previousDashboards };
    },
  });
}
